export default __webpack_public_path__ + "static/media/rotate-cw.7859752f.svg";